import artist from "./artist";
import label from "./label";
import merch from "./merch";
import musicProductDigital from "./music-product-digital";
import musicProductPhysical from "./music-product-physical";
import track from "./track";
import digitalDelivery from "./digital-delivery";
import advance from "./advance/index";
import income from "./income";
import cost from "./cost";
import video from "./video";
export default {
  artist,
  track,
  musicProductDigital,
  musicProductPhysical,
  merch,
  label,
  advance,
  income,
  cost,
  video,
  digitalDelivery,
};
